module.exports = __webpack_public_path__ + "img/icon-gyro.64074e77.svg";